import React from 'react'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import $ from 'jquery';
import alterarSenhaUsuario from '../../../actions/usuario/alterarSenhaUsuario'
import {buscarUsuarios} from '../../../actions/usuario/buscarUsuarios';
import capitalizarTodasPrimeirasLetras from '../../../util/capitalizarTodasPrimeirasLetras';
import {logoutUser} from '../../../actions/util/authenticationJwtActions';
import {minTamnhoCampo, required} from '../../../util/inputs';
import {showSuccessMsg} from '../../../util/messagesUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.confirmarSenha) {
    errors.confirmarSenha = 'Campo obrigatório'
  }
  if (values.senha && values.confirmarSenha) {
    if (values.senha !== values.confirmarSenha) {
      errors.confirmarSenha = 'As senhas são diferentes'
    }
  }


  return errors
};

const renderField = ({
  input,
  label,
  type,
  css,
  max,
  cod,
  readOnly,
  meta: { touched, error }
}) => (
  <div>
    <label className='mt-2'>{label}</label>
    <div>
      <input {...input} type={type}
             className={css}
             maxLength={max}
             style={{ borderColor: touched && error ? 'red' : '' }}
             disabled={readOnly || cod}
             readOnly={readOnly}/>
      {touched
      && (error && <span style={{ color: 'red' }}>{error}</span>)}
    </div>
  </div>
);

export class ModalAlterarSenhaUsuario extends React.Component {
  constructor (props) {
    super(props);
    this.limparCampos = this.limparCampos.bind(this);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
  }

  fecharModal () {
    $('#modalAlterarSenhaUsuario')
      .modal('hide');
    $('#modalAlterarSenhaUsuario')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  submit (values) {
    this.props.alterarSenhaUsuario(values.senha, values.senhaAtual).then(() => {
        this.fecharModal();
        showSuccessMsg('Senha alterada com sucesso. Efetue o login novamente.');
        this.props.logoutUser();
    })
  }

  limparFormulario () {
    this.props.reset('formAlterarSenhaUsuario');
  }

  limparCampos () {
    this.props.changeFieldValue('formAlterarSenhaUsuario',
      'senha', '');
    this.props.changeFieldValue('formAlterarSenhaUsuario',
      'novaSenha', '');
  }


  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalAlterarSenhaUsuario' role='dialog'
           aria-labelledby='modalAlterarSenhaUsuario' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-lg'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Alterar senha</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-group">
                  <Field name="senhaAtual" type="password" validate={[required, minTamnhoCampo]} component={renderField} label="Senha Atual:"
                         css="form-control col-md-12" readOnly={this.props.idUsuario > 0}/>
                </div>
                <div className="form-group">
                  <Field name="senha" type="password" validate={[required, minTamnhoCampo]} component={renderField} label="Nova Senha:"
                         css="form-control col-md-12" readOnly={this.props.idUsuario > 0}/>
                </div>
                <div className="form-group">
                  <Field name="confirmarSenha" type="password" validate={[required, minTamnhoCampo]} component={renderField} label="Confirmar Senha:"
                         css="form-control col-md-12" readOnly={this.props.idUsuario > 0}/>
                </div>
                <div className="modal-footer">
                  <button type="submit" disabled={invalid || submitting || pristine}
                              className="btn btn-laranja">Salvar
                    </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export function mapStateToProps ({ authentication: { nomeUsuario } }) {
  return {
    nomeUsuario: capitalizarTodasPrimeirasLetras(nomeUsuario)
  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    alterarSenhaUsuario,
    buscarUsuarios,
    logoutUser
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formAlterarSenhaUsuario',
  validate
})(ModalAlterarSenhaUsuario));
